import { Component } from '@angular/core';

@Component({
    selector: 'gh-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent { }
